import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import AdManager from '../components/AdManager';
import RewardsCenter from '../components/RewardsCenter';
import GameMonetizeVideo from '../components/GameMonetizeVideo';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiGift, FiSettings, FiVideo } = FiIcons;

const AdDashboard = () => {
  const [activeTab, setActiveTab] = useState('rewards');

  const tabs = [
    { id: 'rewards', label: 'Rewards', icon: FiGift },
    { id: 'videos', label: 'Videos', icon: FiVideo },
    { id: 'settings', label: 'Settings', icon: FiSettings }
  ];

  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 p-4 pb-24"
    >
      <div className="flex justify-between items-center mb-6 pt-4">
        <Link to="/profile" className="text-white hover:text-purple-400 transition-colors">
          <SafeIcon icon={FiArrowLeft} className="w-6 h-6" />
        </Link>
        <h1 className="text-2xl font-bold text-white">Ad Rewards</h1>
        <div className="w-6" />
      </div>

      <div className="flex space-x-2 mb-6 bg-white/10 rounded-xl p-1 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 min-w-[100px] py-2 px-4 rounded-lg font-bold transition-all whitespace-nowrap ${
              activeTab === tab.id 
                ? 'bg-white text-purple-900' 
                : 'text-white hover:bg-white/10'
            }`}
          >
            <SafeIcon icon={tab.icon} className="w-4 h-4 inline mr-2" />
            {tab.label}
          </button>
        ))}
      </div>

      <div className="min-h-[60vh]">
        <AnimatePresence mode="wait">
          {activeTab === 'rewards' && (
            <motion.div
              key="rewards"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              <RewardsCenter />
            </motion.div>
          )}

          {activeTab === 'videos' && (
            <motion.div
              key="videos"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="space-y-4"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10 text-center mb-4">
                <h3 className="text-white font-bold text-lg">Featured Videos</h3>
                <p className="text-gray-400 text-sm">Watch content from our partners</p>
              </div>
              
              <GameMonetizeVideo />
              
              <div className="text-center text-xs text-gray-500 mt-4">
                Powered by GameMonetize
              </div>
            </motion.div>
          )}

          {activeTab === 'settings' && (
            <motion.div
              key="settings"
              className="text-center p-8 text-gray-400 bg-white/5 rounded-xl border border-white/5"
            >
              <div className="text-4xl mb-4">⚙️</div>
              <p>Ad preferences and settings are managed in your main Profile.</p>
              <Link to="/profile" className="inline-block mt-4 text-green-400 font-bold hover:underline">
                Go to Profile
              </Link>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <AdManager showAdButton={true} position="bottom-right" />
    </motion.div>
  );
};

export default AdDashboard;